"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PESPacket = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PESPacket =
/*#__PURE__*/
function () {
  function PESPacket(reader, cntID) {
    _classCallCheck(this, PESPacket);

    this.data = [];
    this.objType = 'PESPacket';
    this.header = {};
    this.header.cntID = cntID;
    this.header.startCode = reader.readBits(24);
    this.header.streamID = reader.readBits(8);
    this.header.packetLength = reader.readBits(16);
    var bitAfterPacketLengthCheck = reader.currentBit();
    this.header.markerBits = reader.readBits(2); // 10

    if (this.header.markerBits !== 2) {
      return;
    }

    this.header.scramblingControl = reader.readBits(2);
    this.header.priority = reader.readBit();
    this.header.alignmentIndicator = reader.readBit();
    this.header.copyright = reader.readBit();
    this.header.originalOrCopyright = reader.readBit();
    this.header.ptsDtsFlags = reader.readBits(2);
    this.header.escrFlag = reader.readBit();
    this.header.esRateFlag = reader.readBit();
    this.header.dsmTrickMode = reader.readBit();
    this.header.additionalCopyInfoFlag = reader.readBit();
    this.header.pesCRCFlag = reader.readBit();
    this.header.pesExtFlag = reader.readBit();
    this.header.pesHeaderDataLength = reader.readBits(8);
    var bitAfterHeaderLengthCheck = reader.currentBit();

    if (this.header.ptsDtsFlags === 2) {
      reader.readBits(4);
      var low = reader.readBits(3);
      reader.readBit();
      var mid = reader.readBits(15);
      reader.readBit();
      var high = reader.readBits(15);
      reader.readBit();
      this.header.pts = buildTimestamp(low, mid, high);
    }

    if (this.header.ptsDtsFlags === 3) {
      reader.readBits(4);

      var _low = reader.readBits(3);

      reader.readBit();

      var _mid = reader.readBits(15);

      reader.readBit();

      var _high = reader.readBits(15);

      reader.readBit();
      this.header.pts = buildTimestamp(_low, _mid, _high);
      reader.readBits(4);
      _low = reader.readBits(3);
      reader.readBit();
      _mid = reader.readBits(15);
      reader.readBit();
      _high = reader.readBits(15);
      reader.readBit();
      this.header.dts = buildTimestamp(_low, _mid, _high);
    }

    if (this.escrFlag) {
      reader.readBits(2);

      var _low2 = reader.readBits(3);

      reader.readBit();

      var _mid2 = reader.readBits(15);

      reader.readBit();

      var _high2 = reader.readBits(15);

      reader.readBit();
      var ext = reader.readBits(9);
      reader.readBit();
      this.header.scr = buildTimestamp(_low2, _mid2, _high2);
      this.header.scrExt = ext;
    }

    if (this.header.esRateFlag) {
      reader.readBit();
      this.header.esRate = reader.readBits(22);
      reader.readBit();
    }

    if (this.header.additionalCopyInfoFlag) {
      reader.readBit();
      this.header.additionalCopyInfo = reader.readBits(7);
    }

    if (this.header.pesCRCFlag) {
      this.header.pesCRC = reader.readBits(16);
    }

    if (this.header.pesExtFlag) {
      this.header.pesPrivateHeaderFlag = reader.readBit();
      this.header.packHeaderFieldFlag = reader.readBit();
      this.header.programPacketSeqCounterFlag = reader.readBit();
      this.header.pSTDBufferFlag = reader.readBit();
      reader.readBits(3);
      this.header.pesExtFlag2 = reader.readBit();
    }

    if (this.header.programPacketSeqCounterFlag) {
      reader.readBit();
      this.header.packetSeqCounter = reader.readBits(7);
      reader.readBit();
      this.header.mpegIdent = reader.readBit();
      this.header.stuffingLength = reader.readBit(6);
    }

    if (this.header.pSTDBufferFlag) {
      reader.readBits(2);
      this.header.pSTDBufferScale = reader.readBit();
      this.header.pSTDBufferSize = reader.readBits(13);
    }

    if (this.header.pesExtFlag2) {
      reader.readBit();
      this.header.pesExtFieldLength = reader.readBits(7);
      reader.readBits(8);
    }

    var bitAfterHeaderParsing = reader.currentBit();
    var parsedBytes = (bitAfterHeaderParsing - bitAfterHeaderLengthCheck) / 8;

    if (parsedBytes !== this.header.pesHeaderDataLength) {
      console.log('!!!! Failed to parse full PES packet. !!!!');
      console.log(this);
      console.log('parsed bytes:', parsedBytes);
      console.log('parsed header length:', this.header.pesHeaderDataLength);
      console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    }

    while (1) {
      if (reader.atEnd()) {
        break;
      }

      if (this.isFull) {
        break;
      }

      var byte = reader.readBits(8);

      if (byte === undefined) {
        break;
      }

      this.push(byte);
    }
  }

  _createClass(PESPacket, [{
    key: "push",
    value: function push(bytes) {
      this.data.push(bytes);
    }
  }, {
    key: "length",
    get: function get() {
      return this.data.length;
    }
  }, {
    key: "isFull",
    get: function get() {
      if (this.header.packetLength) {
        var lng = this.header.packetLength;
        lng -= 3; // There are 24 bits between the packet length and the pes header length

        lng -= this.header.pesHeaderDataLength;

        if (this.data.length === lng) {
          return true;
        } else {
          return false;
        }
      }

      return false;
    }
  }]);

  return PESPacket;
}();

exports.PESPacket = PESPacket;

var buildTimestamp = function buildTimestamp(low, mid, high) {
  var ts = 0;
  ts = ts << 3 | low;
  ts = ts << 15 | mid;
  ts = ts << 15 | high;
  ts = ts >>> 0;
  return ts;
};

var _default = PESPacket;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/pes-packet.js
// module id = 476
// module chunks = 0